import { Component } from '@angular/core';
import { MediaSettingsModule } from '@onclass/oc-mediasettings';
import { UserVideoComponent } from './components/user-video/user-video.component';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    CommonModule,
    UserVideoComponent,
    MediaSettingsModule,
  ],
})
export class AppComponent {
  settingsOpen = false;
  error: { header: string; text: string } | null = null;
  disabled = false;

  openSettings() {
    this.settingsOpen = true;
  }

  closeSettings() {
    this.settingsOpen = false;
  }

  handleUserVideoEvent(action: string) {
    if (action === 'settings') {
      this.openSettings();
    }
  }
}
